import React, { useState, useEffect, useCallback } from "react";
import script_model from "models/script_model";
import org_model from "models/org_model";
import { Input, Button, Form, Message, Popup, Icon, Radio } from "semantic-ui-react";
import UniFormMed from "views/med/UniFormMed";
import gtm from "xAppLib/providers/gtm";
import CopayPopup from "../../MHCPCopayPopup";
import currency from "currency.js";
import med_model from "@iscr/models/med_model";
import discounts_model from "../../../../models/discounts_model";
import { ONEPASS_FIRST_TIME_CODE } from "constants";

const Summary = (props) => {
	const { med_data, cart, store, script_type, req_type, is_prep, onUpdate, Section, evermed, onepassEligible, setDiscount, enable_refer } = props
	const [loadingDiscount, setLoadingDiscount] = useState(false);
	const [errorDiscount, setErrorDiscount] = useState(false);
	const [refReward, setRefReward] = useState();
	const [disc, setDisc] = useState();
	const onePassReward = cart.discount?.code === 'op';

	const content = cart.content()

	const copay = med_model.has_copay(med_data);

	const applyDiscount = useCallback(discount_code=>{
		(async _ => {
			const code = (discount_code||'').trim()
            if(!code) return;
			setLoadingDiscount(true)
			const success = await cart.add_discount(code)
			setLoadingDiscount(false)
			setErrorDiscount(!success)
			
			const content = cart.content()
			const fail = content.discount_error || !success && "Discount not applied"
			const evt = fail?'apply_discount_fail':'apply_discount_success'
            setDiscount(cart.discount);

            gtm.event(evt,`${evt}_${code}`,{resp:fail||'OK'})

		})()
	},[]) 

	const applyReferralDiscount = useCallback(async () => {
		const {res, discount} = await discounts_model.get_referral_code()
		if(res === 'ok') {
			const code = discount?.code
			const reward = await discounts_model.get_discount_by_code(code)
			if(reward?.res === 'ok' && code && (reward?.max_use - reward?.used > 0)){ 
				setRefReward(code)
				applyDiscount(code)
			}
		}
	}, [med_data]);
	
	useEffect(() => {
        if (app.user?.user_in && enable_refer) applyReferralDiscount()
    }, []);

	const applyOnepassDiscount = useCallback(() => {
       	if(onepassEligible/* checks relating to med type/copay have been done in MedForm */) {
			applyDiscount('op')
		}
	}, [onepassEligible]);

	useEffect(()=>{
		if (app.runtime.get_params_init?.get('disc')) {
			applyDiscount(app.runtime.get_params_init.get('disc').trim())
		}
	},[])

	useEffect(() => {
        if (cart?.discount?.type != 'reward_referral') applyOnepassDiscount()
    }, [onepassEligible, med_data]);

	const handleSelect = (e, { value }) => {
		value === 'op' ? applyDiscount('op') : applyDiscount(refReward)
		setDisc(value)
	}

	if (content.subtotal.value == 0)
		return null


	return (
		<UniFormMed
			{...props}
			section="summary"
			fields={script_model.COMM_DISCOUNT_FIELDS}
		>
			{(values, valids, uf_this, fields) => {
				return <Section>
				

						<Section.Header>Summary</Section.Header>
						<Section.Content start>
							<h3 className="text-base">Purchase order</h3>
							<hr className="h-px bg-is-gray-50 border-0 mb-4 -mx-4"></hr>
							{content.items.map((item,index)=>item.id !== 'DISCOUNT' && item.id !== 'CREDIT' && <div className="flex text-is-black-80" data-testid="text-item" key={index} style={{margin:'0 0 10px'}}>
								<div className="w-full pr-4">
									<label className="text-sm font-semibold" data-testid="text-item-name">{item?.quantity || 1} x {item.name}</label>
									{item.description && !(is_prep && item.id == 'MEDCONS') && <div><small>{item.description}</small>
										{item.name == 'Premium Home Delivery by Chemist2U' &&
											<React.Fragment>
												<Popup position='top center' trigger={<Icon size="small" style={{marginLeft:'5px'}} name="question circle outline" color="blue" />}>
													<Popup.Header>Chemist2U delivery time</Popup.Header>
													<Popup.Content>Delivery times are an estimate only. Greater than 95% of C2U deliveries are within the communicated timeframe.<br/><br/>
													Deliveries that are over 24 hours later than the communicated timeframe and without a communicated reason could be reimbursed for the shipping cost.<br/><br/>C2U does not deliver to PO Boxes.</Popup.Content>
												</Popup>
											</React.Fragment>}
									</div>}
									{item.id=='MEDBUY' && cart.has_branded && cart.has_generic && !evermed.enabled && <div>
										<Form.Checkbox style={{paddingLeft:'25px'}}
											label={ <label>
														Allow brand substitution.
														<Popup
																position='top center'
																trigger={<Icon
																			size="small"
																			style={{marginLeft:'5px'}}
																			name="question circle outline"
																			color="green" />}
															>
															<Popup.Header>Brand substitution</Popup.Header>
															<Popup.Content>
																Medication that is bioequivalent and contains the same active ingredients
															</Popup.Content>
														</Popup>
													</label> }
											checked={store.want_gen}
											onChange={ _=> {
														onUpdate({want_gen:!store.want_gen})
													} }
											/>

										</div> }
										{item.id=='MEDBUY' && !cart.has_branded && cart.has_generic && <div><small>
											Only brand substitution is available. (Medication that is bioequivalent and contains the same active ingredients.)
										</small></div> }
										{item.id == 'DOCCONS' && copay && <div><small>
											You will see a pending charge for the full amount of {currency(med_data.xtra?.copay).add(med_data.xtra?.mhcp).format()} on your card until the Medicare rebate is issued and the doctor determines which consultation is right for you. After the Medicare rebate your out-of-pocket cost is $49. <CopayPopup  config={med_data.xtra} content={<span className='underline'>See how our pricing works here.</span>}/>
										</small></div>}
									</div>
									<div>
										<label className="text-sm font-semibold" data-testid="text-item-price">

											<React.Fragment>
												<p className={`mb-0 ${Number(item.discounted) ? 'line-through' : ''}`}>{item.price.format?.() || (item.price === 0 ? 'Free' : item.price)}</p>
												{Number(item.discounted) < 0 && <p className="mb-0">{Number(item.price) + Number(item.discounted) === 0 ? 'Free' : currency(Math.abs(Number(item.price) + Number(item.discounted))).format()}</p>}
											</React.Fragment>
										</label>
									</div>
								</div>)}

							{content.tax.value > 0 &&
								<React.Fragment>
									<hr className="h-px bg-is-gray-50 border-0 -mx-4"></hr>
									<div className={'flex flex-row justify-between my-3'}>
										<p className={'text-xs m-0'}>GST (included)</p>
										<p className={'text-xs m-0'}>{content.tax.format()}</p>
									</div>
								</React.Fragment>}
						{!org_model.org_conf_itm(app.runtime.org, 'hide_discounts') &&
						!org_model.org_conf_itm(app.user?.org, 'hide_discounts') && <>
							<hr className="h-px bg-is-gray-50 border-0 mb-4 -mx-4"></hr>
							<div className="pb-4">
								<h3 className="text-base">{!app.settings.iscr2 && 'Discount code'}{(refReward && onePassReward) && <><br/><small>You can only use 1 discount code per transaction</small></>}</h3>
						
								<Form.Group
									widths='equal'
									className='discount-field !mr-0' // overriding the -0.5em in _form.scss which causes misalignment
								>
										<Form.Input 
											name="discount_code"
											value={values.discount_code||''}
											onChange={uf_this.handleInputChange}
											type='text'
											placeholder="Discount code"
											success = {(!errorDiscount).toString()} 
											error = {!!errorDiscount} 
											fluid 
											control = {Input}
											data-testid="input-discount-code"
											label="Discount code"
										/> 

									<Button type="button"
										loading={loadingDiscount}
										basic
										size='tiny'
										data-testid="button-apply-discount"
										onClick={ _ => applyDiscount((values.discount_code||'').trim()) }
										>Apply</Button>
								</Form.Group>
								{(errorDiscount||content.discount_error)  && 
									<Message  size='mini' negative>
										<p data-testid='text-discount-error'>{content.discount_error || 'Invalid discount code'}</p>
									</Message>}
							</div>
						</>}

						{onepassEligible === true && !refReward && ((content.discount < 0 && !content.items.some(({ code }) => ['op'].includes(code))) || (errorDiscount || content.discount_error)) && <>
							<hr className="h-px bg-is-gray-50 border-0 -mx-4"></hr>
                            <div>
                                <svg width="86" height="44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="icon-title-2978598" viewBox="0 0 86 44" aria-label="OnePassLogoFrame" aria-describedby="icon-title-2978598" titleid="icon-title-2978598"><title>OnePassLogoFrame</title><path d="M34.623 21.617c-1.574 0-3.012.546-4.048 1.538-1.042.997-1.617 2.387-1.617 3.914 0 1.54.587 2.928 1.65 3.905 1.102 1.013 2.629 1.548 4.417 1.548 1.87 0 3.322-.55 4.318-1.637l-1.528-1.653c-.765.69-1.605.998-2.71.998-1.69 0-2.888-.842-3.204-2.254l-.03-.133h8.224a9.69 9.69 0 01.013-.145c.02-.208.039-.423.039-.588 0-1.639-.55-3.03-1.59-4.025-.992-.946-2.388-1.468-3.934-1.468zm.02 2.15c1.427 0 2.5.893 2.752 2.278h-5.524c.252-1.406 1.308-2.277 2.772-2.277zm-8.317-1.026c.83.81 1.252 2.003 1.252 3.545v6.075h-2.92v-5.593c0-1.74-.796-2.66-2.303-2.66-.641 0-1.304.258-1.772.744-.506.528-.762 1.294-.762 2.277v5.231H16.9V21.778h2.78v1.437l.19-.208c.82-.896 2.18-1.39 3.33-1.39 1.291 0 2.371.389 3.125 1.123zM9.753 14.398A5.695 5.695 0 005.71 16.08L0 21.776h4.047v5.05c0 3.14 2.56 5.697 5.707 5.697s5.707-2.557 5.707-5.698v-6.73c0-3.14-2.561-5.697-5.708-5.697zm2.845 12.427a2.846 2.846 0 01-5.69 0v-5.05h-2.86l3.697-3.69a2.846 2.846 0 014.853 2.01v6.73zm33.618-8.947h-4.713v14.483h2.955v-4.522h1.758c3.705 0 6.007-1.904 6.007-4.97 0-3.078-2.302-4.99-6.007-4.99zm-.18 7.53h-1.578v-5.097h1.578c2.004 0 3.107.91 3.107 2.56 0 1.635-1.104 2.537-3.107 2.537zm28.734 3.79c0 .969-.432 1.791-1.25 2.38-.857.618-2.095.945-3.58.945-1.627 0-3.376-.439-4.395-1.096l.921-2.05c.965.606 2.357.995 3.589.995 1.365 0 2.03-.357 2.03-1.093 0-.784-1.032-.94-2.225-1.12-1.823-.276-4.092-.618-4.092-3.157 0-2.056 1.858-3.384 4.733-3.384 1.44 0 2.95.343 3.887.88l-.921 2.031a6 6 0 00-2.965-.76c-1.849 0-2.049.778-2.049 1.113 0 .827 1.06.998 2.287 1.195 1.796.288 4.03.648 4.03 3.121zm10.278 0c0 .969-.679 1.791-1.496 2.38-.857.618-2.095.945-3.581.945-1.627 0-3.375-.439-4.394-1.096l.92-2.05c.965.606 2.358.995 3.59.995 1.365 0 2.029-.357 2.029-1.093 0-.784-1.031-.94-2.225-1.12-1.822-.276-4.091-.618-4.091-3.157 0-2.056 1.857-3.384 4.733-3.384 1.44 0 3.197.343 4.132.88l-1.168 2.031a6 6 0 00-2.964-.76c-1.85 0-2.05.778-2.05 1.113 0 .827 1.06.998 2.288 1.195 1.795.288 4.277.648 4.277 3.121zm-23.733-6.385v.288l-.191-.215c-.738-.83-1.83-1.268-3.157-1.268-3.122 0-5.302 2.242-5.302 5.453 0 3.21 2.18 5.452 5.302 5.452 1.433 0 2.542-.46 3.295-1.366l.193-.232v1.438h2.779V21.778h-2.92v1.035zm-.767 6.529c-.515.534-1.238.829-2.038.829-.808 0-1.622-.295-2.14-.83-.543-.56-.83-1.346-.83-2.271 0-.925.287-1.71.83-2.272.517-.534 1.332-.829 2.14-.829.8 0 1.523.295 2.038.829.542.562.828 1.348.828 2.272 0 .924-.287 1.71-.828 2.271z" fill="#9900F1"></path></svg>
                                <p style={{marginTop: 7, marginBottom: 14}}>Your OnePass member benefits are not applied because you have applied a discount code. <span style={{ textDecoration:'underline', cursor: 'pointer' }} onClick={ () => applyOnepassDiscount()}>Remove discount code to apply OnePass benefits instead.</span></p>
                            </div>
						</> }

                        {content.discount < 0 && <>
                            <hr className="h-px bg-is-gray-50 border-0 -mx-4"></hr>
                            <div data-testid="text-subtotal" className="flex justify-between -mx-4 p-4">
                                <p className="text-base m-0">Subtotal</p>
                                <h5 className="m-0">{content.subtotal.format()}</h5>
                            </div>
                            <hr className="h-px bg-is-gray-50 border-0 -mx-4"></hr>
                            <div data-testid="text-discount" className="flex justify-between -mx-4 p-4">
                                <p className="text-base m-0">Discount {!(refReward && onePassReward) && <>({cart.discount.code === 'op' && 'OnePass member benefits' || cart.discount.code === ONEPASS_FIRST_TIME_CODE && 'OnePass member benefits first purchase' || (refReward === cart.discount.code) && 'Referral reward' || cart.discount.code})</>}</p>
                                <h5 className="m-0">{content.discount.format()}</h5>
                            </div>
							
							{(refReward && onePassReward) && 
								<div className="card flex flex-col mb-4 text-sm">
									<Radio
										label={<label className="hover:text-is-blue cursor-pointer">Referral reward {!disc && <>(applied automatically)</>}</label>}
										value="ref"
										checked={cart?.discount?.type === 'reward_referral'}
										onChange={handleSelect}
									/>
									<Radio
										label={<label className="hover:text-is-blue cursor-pointer">OnePass discount</label>}
										value="op"
										checked={cart?.discount?.code === 'op'}
										onChange={handleSelect}
									/>
								</div>
							}
							
                        </>}

                        {content.credit < 0 && <>
                            <hr className="h-px bg-is-gray-50 border-0 -mx-4"></hr>
                            <div data-testid="text-subtotal" className="flex justify-between -mx-4 p-4">
                                <p className="text-base m-0">Credit Applied</p>
                                <h5 className="m-0">{content.credit.format()}</h5>
                            </div>
                        </>}
						<hr className="h-px bg-is-gray-50 border-0 -mx-4"></hr>

						<div data-testid="text-total" className="flex justify-between bg-is-blue-20 -mx-4 p-4 -mb-4">
							<p className="text-base m-0">Total</p>
							<h5 className="m-0">{content.total == 0 ? "FREE" : content.total.format()}</h5>
						</div>

						</Section.Content>
				</Section>;
			}}
		</UniFormMed>
	);
};

export default Summary;

